import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import Log from './section-components/log';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Log of Projects"  />
        <Log />
        <Footer />
    </div>
}

export default SignInPage

